import { graphql, useStaticQuery } from 'gatsby';

export function formatGettingStartedData(data: any) {
  const gettingstartedMap = {};
  for (const g of data.gettingstarted.edges) {
    const software = g.node.fields.gettingstarted;
    if (!gettingstartedMap[software]) {
      gettingstartedMap[software] = { steps: [], cores: {} };
    }
    if (g.node.fields.core) {
      gettingstartedMap[software].cores[g.node.fields.core] = g;
    } else {
      gettingstartedMap[software].steps.push(g);
    }
  }

  return gettingstartedMap;
}

export function useGettingStartedMap() {
  const data = useStaticQuery(graphql`
    query Query {
      gettingstarted: allFile(filter: { fields: { type: { eq: "softwarepage" }, gettingstarted: { ne: null } } }, sort: { fields: { slug: ASC } }) {
        edges {
          node {
            fields {
              slug
              gettingstarted
              software
              core
            }
            childMdx {
              body
              tableOfContents
              frontmatter {
                title
                description
              }
            }
          }
        }
      }
    }
  `);

  const gettingstartedMap = formatGettingStartedData(data);

  return gettingstartedMap;
}
